<template>
  <div>
    <div class="col-md-9 cadastro">
      <p>
        Informe o e-mail de contato do associado que deseja cadastar no campo
        abaixo. Será enviado um e-mail informando a solicitação do novo cadastro
        e o link para o associado Assinar e Aceitar o termo de aceite. Após
        confirmação, você poderá dar continuidade ao cadastro do associado na
        tela de "Gerenciar Associado".
      </p>
      <div>
        <FormulateInput
          type="email"
          name="email"
          label="Email"
          v-model="email"
          validation="required|email"
        />
      </div>
    </div>
    <div>
      <div class="row mt-5 flex-column-reverse flex-md-row">
        <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
          <Botao
            title="Voltar"
            @click="$router.push({ name: 'Dashboard' })"
            nameClass="btn btn-outline-secondary btn-lg btn-block"
            >VOLTAR</Botao
          >
        </div>
        <div class="col-md-4 col-lg-3">
          <Botao
            title="Enviar"
            :class="{ disabled: loading }"
            @click="!loading ? solicitar() : ''"
            nameClass="btn btn-success btn-lg btn-block font-weight-bold"
          >
            <span
              class="spinner-grow spinner-grow-sm pr-2"
              role="status"
              aria-hidden="true"
              v-show="loading"
            ></span>
            <span v-if="loading">ENVIANDO...</span>
            <span v-else>SOLICITAR</span>
          </Botao>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Botao from "@/components/botoes/Botao";
export default {
  name: "CartaDeclaracao",
  components: { Botao },
  data() {
    return {
      produto: {
        nome: "Nova Filiação",
        id: "novaFiliacao",
      },
      loading: false,
      breadcrumb: [
        {
          nome: "Nova Filiacao",
          id: "novaFiliacao",
        },
      ],
      email: "",
    };
  },
  methods: {
    solicitar() {
      this.loading = true;
      this.$http
        .post(`/api/Consultor/EnviarEmailFuturoAssociado?email=${this.email}`)
        .then((response) => {
          this.loading = false;
          this.$toast.open({
            message: response.data.mensagem,
            type: "success",
          });
          this.$router.push({ name: "gerenciarAssociados" });
        })
        .catch(() => {
          this.loading = false;
          this.$toast.open({
            message: "Erro ao solicitar declaração, tente novamente.",
            type: "error",
          });
        });
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
@import "@/assets/scss/_vars.scss";
.cadastro /deep/ {
  @import "@/assets/scss/_vue-formulate.scss";
  background: white;
  padding: 2rem;
  max-width: 800px;
  border-radius: 6px;
  .formulate-input {
    margin-top: 1rem;
    .formulate-input-wrapper {
    }
    .formulate-input-label {
      margin-bottom: 0.5rem;
    }

    .formulate-input-element {
      padding: 5px;
      background: $dark-100;
      input,
      select {
        background: $dark-100;
      }
    }
    &[data-classification="select"] {
      select {
        width: 100%;
        height: 100%;
      }
    }
    &[data-classification="button"] {
      &,
      .formulate-input-element {
        padding: 0;
        background-color: transparent;
      }
      button {
        padding-left: 1.4rem;
        padding-right: 1.4rem;
      }
    }
  }
}
</style>
